const translations = {
  title: 'Nuevo destino',
  title_edit: 'Editando destino',
  bulkRegistration: 'Registro masivo',
  type: 'Tipo*',
  additionalFields: 'Campos adicionales'
}

export default translations
